const correctActive = () => {
    const mainMenuParent = document.getElementById('navbarSupportedContent');
    let mainMenuList = undefined;
    if(mainMenuParent !== null){
        mainMenuList = mainMenuParent.querySelector('.navbar-nav');
    }

    if(mainMenuList !== undefined){
        const menu = mainMenuList;
        const baseUrl = window.location.href;

        const allLinks = menu.querySelectorAll('a');
        let hashes = [];
        allLinks.forEach(link => {
            let parent = link.parentNode;
            if(link.href.includes('#')){
                link.classList.remove('active');
                parent.classList.remove('active');
                parent.classList.remove('current-menu-item');
                if(link.href.split('#')[0] === baseUrl && link.href.split('#')[1] !== ''){
                    hashes[link.href.split('#')[1]] = link;
                }

            }

        })
        const hashKeys = Object.keys(hashes);
        document.addEventListener('scroll', ev => {
            if(timer){
                window.clearTimeout(timer);
            }
            let timer = window.setTimeout( () =>{
                const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                let mostVisibleKey = null;
                let maxOverlap = 0;
                hashKeys.forEach(key => {
                    const el = document.getElementById(key);
                    if(el === null){
                        return;
                    }
                    const bounding = el.getBoundingClientRect();
                    const verticalOverlap = Math.min(bounding.bottom, viewportHeight) - Math.max(bounding.top, 0);
                    const horizontalOverlap = Math.min(bounding.right, viewportWidth) - Math.max(bounding.left, 0);
                    if(verticalOverlap > 0 && horizontalOverlap > 0 && verticalOverlap > maxOverlap){
                        maxOverlap = verticalOverlap;
                        mostVisibleKey = key;
                    }
                })
                hashKeys.forEach(key => {
                    if(key === mostVisibleKey){
                        hashes[key].classList.add('active');
                    } else {
                        hashes[key].classList.remove('active');
                    }
                })
            }, 1000);
        })
    }

}
export default correctActive;